export default "__VITE_ASSET__CVBJreTa__"